import { useState } from 'react';
import type { JSX } from 'react';
import { date, num } from '../lib/format.js';

export interface RaceChoice {
  raceId: string;
  name: string;
  dateStart: string | null;
  phase?: 'past' | 'ongoing' | 'upcoming' | 'undated';
  cancelled?: boolean;
  buyers: number;
  watchdogs: number;
}

/**
 * Výběr závodu: ve výchozím stavu jen aktivní (nadcházející, probíhající, bez data), bez proběhlých a zrušených.
 * Zaškrtnutím se ukážou i starší závody (posledních 12 měsíců). Vybraný starší závod zůstává vidět.
 */
export function RaceSelect({
  races,
  value,
  onChange,
  emptyLabel,
  ariaLabel = 'Závod',
}: {
  races: RaceChoice[];
  value: string;
  onChange: (raceId: string) => void;
  emptyLabel: string;
  ariaLabel?: string;
}): JSX.Element {
  const [showAll, setShowAll] = useState(false);
  const active = (r: RaceChoice): boolean => r.phase !== 'past' && !r.cancelled;
  const shown = races.filter((r) => showAll || active(r) || r.raceId === value);
  const hidden = races.length - races.filter(active).length;
  return (
    <>
      <select value={value} onChange={(e) => onChange(e.target.value)} aria-label={ariaLabel}>
        <option value="">{emptyLabel}</option>
        {shown.map((r) => (
          <option key={r.raceId} value={r.raceId}>
            {r.name}
            {r.dateStart ? ` · ${date(r.dateStart)}` : ''}
            {r.phase === 'past' ? ' · proběhl' : ''}
            {r.cancelled ? ' · zrušen' : ''} · koupilo {num(r.buyers)} · hlídá {num(r.watchdogs)}
          </option>
        ))}
      </select>
      {hidden > 0 ? (
        <label className="row">
          <input type="checkbox" checked={showAll} onChange={(e) => setShowAll(e.target.checked)} />
          <span className="note">
            Zobrazit i proběhlé a zrušené závody ({num(hidden)}, posledních 12 měsíců)
          </span>
        </label>
      ) : null}
    </>
  );
}
